<template>
    <div style="width: 98%; margin: auto">
        <ul class="cic-module">
            <li class="cic-header">
                <span class="cic-header-title">{{ $t('FLOW Global Variables') }}</span>
            </li>
            <li style="overflow-x: auto">
                <table v-if="show" id="variables_table" class="cic-table">
                    <thead>
                        <tr>
                            <th>{{ $t('Variable Name') }}</th>
                            <th>{{ $t('Variable Type') }}</th>
                            <th>{{ $t('Variable Value') }}</th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(variable, variableIndex) in variables">
                            <td>{{ variable.name }}</td>
                            <td>
                                <cic-select :enabled="false" :options="typeOptions" :value="variable.type" />
                            </td>
                            <td>
                                <cic-checkbox
                                    v-if="variable.type === 2"
                                    :value="variable.value"
                                    @input="(val) => handleInput(variableIndex, val)"
                                />
                                <cic-textbox
                                    v-else
                                    :value="variable.value"
                                    @input="(val) => handleInput(variableIndex, val)"
                                />
                            </td>
                            <td>
                                <UploadFilled
                                    v-if="changed.includes(variable.variableId)"
                                    :title="$t('Save')"
                                    style="cursor: pointer; width: 27px; vertical-align: text-bottom"
                                    @click="updateVariable(variableIndex)"
                                />
                            </td>
                            <td>
                                <span
                                    :title="$t('Delete Global Variable')"
                                    class="icon remove-icon"
                                    @click="removeVariable(variable.variableId)"
                                >
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <cic-textbox
                                    id="new_variable_name"
                                    :value="newVariable.name"
                                    @input="(val) => (newVariable.name = val)"
                                />
                            </td>
                            <td>
                                <cic-select
                                    id="new_variable_type"
                                    :options="typeOptions"
                                    :value="newVariable.type"
                                    @input="changeType"
                                />
                            </td>
                            <td>
                                <cic-checkbox
                                    v-if="newVariable.type === 2"
                                    id="new_boolean_variable_value"
                                    :value="newVariable.value"
                                    @input="(val) => (newVariable.value = val)"
                                />
                                <cic-textbox
                                    v-else
                                    id="new_variable_value"
                                    :value="newVariable.value"
                                    @input="(val) => (newVariable.value = val)"
                                />
                            </td>
                            <td></td>
                            <td>
                                <span
                                    id="add_new_variable"
                                    :title="$t('Save')"
                                    class="icon add-icon"
                                    @click="addVariable"
                                >
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-else style="padding: 10px; background-color: #eee">{{ $t('DIRECT_LOGIN_REQUIRED') }}</div>
            </li>
            <li class="cic-footer"></li>
        </ul>

        <div v-if="$store.showLoadingOverlay" class="cic-overlay"></div>
    </div>
</template>

<script>
    import { UploadFilled } from '@element-plus/icons-vue';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import CicSelect from '@/components/inputs/CicSelect';
    import CicTextbox from '@/components/inputs/CicTextbox';
    import { deleteItems, load, save } from '@/utils/Http';

    export default {
        name: 'GlobalVariables',
        components: {
            CicCheckbox,
            CicSelect,
            CicTextbox,
            UploadFilled,
        },
        data() {
            return {
                changed: [],
                newVariable: { name: null, type: 0, value: 0 },
                show: true,
                typeOptions: [
                    { value: 0, label: 'Integer' },
                    { value: 1, label: 'String' },
                    { value: 2, label: 'Boolean' },
                    { value: 3, label: 'Float' },
                ],
                variables: [],
            };
        },
        created() {
            this.loadVariables();
        },
        mounted() {
            this.typeOptions = this.typeOptions.map((option) => ({
                value: option.value,
                label: this.$t(option.label),
            }));
        },
        methods: {
            addVariable() {
                if (
                    confirm(
                        this.$t(
                            'Are you sure you want to create a new global variable? Once the variable has been created you cannot edit the name or type.',
                        ),
                    )
                ) {
                    this.saveVariable(this.newVariable);
                    this.newVariable = { name: null, type: 0, value: 0 };
                }
            },

            changeType(val) {
                if (val === 0 || val === 3) {
                    this.newVariable.value = 0;
                } else if (val === 2) {
                    this.newVariable.value = false;
                } else {
                    this.newVariable.value = null;
                }

                this.newVariable.type = val;
            },

            handleInput(variableIndex, val) {
                if (this.variables[variableIndex]['value'] !== val) {
                    this.changed.push(this.variables[variableIndex].variableId);
                    this.variables[variableIndex]['value'] = val;
                }
            },

            loadVariables() {
                this.changed = [];
                load('globalvariables/get', {}, (response) => {
                    if (response.direct) {
                        this.show = false;
                    } else {
                        this.variables = response.variables.map((x) => {
                            let variable = JSON.parse(JSON.stringify(x));
                            if (x.type === 0) {
                                variable.value = parseInt(x.value);
                            } else if (x.type === 2) {
                                variable.value = x.value === '1';
                            } else if (x.type === 3) {
                                variable.value = parseFloat(x.value);
                            }

                            return variable;
                        });
                    }
                });
            },

            removeVariable(variableId) {
                if (confirm(this.$t('Are you sure you want to delete the selected global variable?'))) {
                    deleteItems('globalvariable/delete', { variableId: variableId }, this.loadVariables);
                }
            },

            saveVariable(variable) {
                let value = '';
                if (variable.type === 2) {
                    // boolean
                    value = variable.value ? '1' : '0';
                } else if (variable.value) {
                    value = variable.value;
                } else if ([0, 3].includes(variable.type)) {
                    // int and float
                    value = 0;
                }

                let params = {
                    variableId: variable.variableId ? variable.variableId : null,
                    name: variable.name,
                    type: variable.type,
                    value,
                };
                save('globalvariable/update', params, this.loadVariables);
            },

            updateVariable(variableIndex) {
                if (confirm(this.$t('Are you sure you want to update the value for the selected global variable?'))) {
                    this.saveVariable(this.variables[variableIndex]);
                }
            },
        },
    };
</script>
